import Vue from 'vue';
import Vuex from 'vuex';
import authenticate from './authenticate/actions';
import user from './user/actions';
import admin_document from './administration/document/actions';
import admin_result from './administration/result/actions';
import admin_questionnary from './administration/questionnary/actions';
import admin_user from './administration/user/actions';
import documentation from './documentation/actions';
import company from './company/actions';
import employee from './employee/actions';
import survey from './survey/actions';
import translation from './translation/actions';
import exchange from './exchange/actions';


Vue.use(Vuex);

console.log(authenticate);
export default new Vuex.Store({
  modules: {
    authenticate,
    user,
    admin_questionnary,
    admin_user,
    admin_document,
    documentation,
    company,
    translation,
    employee,
    survey,
    exchange,
    admin_result
  },
  strict: false,
});
